import React,{useState} from 'react';
import {
  Grid,
  Typography,
  FormControl,
  FormLabel,
  FormGroup,
  FormControlLabel,
  FormHelperText,
  Checkbox,
  Radio,
  RadioGroup
} from '@mui/material';
import { List } from 'react-virtualized';
import IconButton from '@mui/material/IconButton';
import AlarmIcon from '@mui/icons-material/Alarm';
import HelpIcon from '@mui/icons-material/Help';
import RiskDialog from "./RiskDialog";
import Select,  {
  components
} from 'react-select';
//import { arrayMove, SortableContext, horizontalListSortingStrategy } from '@dnd-kit/sortable';
import { useSortable } from '@dnd-kit/sortable';

const SortableMultiValue = (props) => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: props.data.value });
  const onMouseDown = (e) => {
      e.preventDefault();
      e.stopPropagation();
  };
  const style = {
      transform: CSS.Transform.toString(transform),
      transition,
      ...props.style,
  };
  const innerProps = { ...props.innerProps, onMouseDown };
  return (
      <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
          <components.MultiValue {...props} innerProps={innerProps} />
      </div>
  );
};

const SortableMultiValueLabel = (props) => {
  const { listeners, setNodeRef } = useSortable({ id: props.data.value });

  return (
      <div ref={setNodeRef} {...listeners}>
          <components.MultiValueLabel {...props} />
      </div>
  );
};

const MonitoraggioDPP = ({
  scelteDisponibiliDPP,
  scelteDPP,
  handleCheckboxChangeDPP,
  handleRadioChangeDPP,
  handleRischioRadioChange,
  handleImpattoSelectChange,
  disabledFattoriChiave,
  errori
}) => {
  const [openRiskDialog, setOpenRiskDialog] = useState(false);

  const handleOpenRiskDialog = () => {
    setOpenRiskDialog(true);
  };

  const handleCloseRiskDialog = () => {
    setOpenRiskDialog(false);
  };

  const showInfoAboutRisks = () => {
    console.log("POSSO MOSTRARE INFO CALCOLO RISCHIO");
    handleOpenRiskDialog();
  };

  const MenuList = props => {
    const rows = props.children;
    const rowRenderer = ({ key, index, isScrolling, isVisible, style }) => (
    <div key={key} style={style}>{rows[index]}</div>
    );

    return (
    <List            
        style={{ width: '100%' }}
        width={500}
        height={300}
        rowHeight={30}
        rowCount={rows.length}
        rowRenderer={rowRenderer}
    />
    )
}
/*
  const listaImpatto = [
    //{ value: 'Nessuno', label: 'Nessuno'},
    { value: 'Arcate MOI', label: 'Arcate MOI' },
    { value: 'Asset Building For Education', label: 'Asset Building For Education' },
    { value: 'Attrazione investimenti e piano industriale', label: 'Attrazione investimenti e piano industriale' },
    { value: 'Cavallerizza Reale', label: 'Cavallerizza Reale'},
    { value: 'Città dell’Educazione', label: 'Città dell’Educazione'},
    { value: 'Evoluzione Enti Strumentali', label: 'Evoluzione Enti Strumentali'},
    { value: 'GAM', label: 'GAM' },
    { value: 'Hub Innovazione Genova', label: 'Hub Innovazione Genova' },
    { value: 'IRCCS Piemonte e Liguria', label: 'IRCCS Piemonte e Liguria'},
    { value: 'MOI 2.0', label: 'MOI 2.0'},
    { value: 'PAAS', label: 'PAAS' },
    { value: 'Progetto Giovani', label: 'Progetto Giovani' },
    { value: 'STEAM', label: 'STEAM'},
    { value: 'Strategia AI e supporto AI4I', label: 'Strategia AI e supporto AI4I'},
    { value: 'RootCare', label: 'RootCare' },
    { value: 'Villa della Regina', label: 'Villa della Regina'},
  ];
  */
  
  const listaImpatto = [    
    /*{ value: 0, label: 'Nessuno'},
    { value: 1, label: 'Arcate MOI' },
    { value: 2, label: 'Asset Building For Education' },
    { value: 3, label: 'Attrazione investimenti e piano industriale' },
    { value: 4, label: 'Cavallerizza Reale'},
    { value: 5, label: 'Città dell’Educazione'},
    { value: 6, label: 'Evoluzione Enti Strumentali'},
    { value: 7, label: 'GAM' },
    { value: 8, label: 'Hub Innovazione Genova' },
    { value: 9, label: 'IRCCS Piemonte e Liguria'},
    { value: 10, label: 'Palazzine MOI'},
    { value: 11, label: 'PAAS' },
    { value: 12, label: 'Progetto Giovani' },
    { value: 13, label: 'STEAM'},
    { value: 14, label: 'Strategia AI e supporto AI4I'},
    { value: 15, label: 'Progetto Alberi' },
    { value: 16, label: 'Villa della Regina'},*/
    { value: 0, label: 'Arcate MOI' },
    { value: 1, label: 'Asset Building For Education' },
    { value: 2, label: 'Attrazione investimenti e piano industriale' },
    { value: 3, label: 'Cavallerizza Reale'},
    { value: 4, label: 'Città dell’Educazione'},
    { value: 5, label: 'Evoluzione Enti Strumentali'},
    { value: 6, label: 'GAM' },
    { value: 7, label: 'Hub Innovazione Genova' },
    { value: 8, label: 'IRCCS Piemonte e Liguria'},
    { value: 9, label: 'Palazzine MOI'},
    { value: 10, label: 'PAAS' },
    { value: 11, label: 'Progetto Giovani' },
    { value: 12, label: 'STEAM'},
    { value: 13, label: 'Strategia AI e supporto AI4I'},
    { value: 14, label: 'Progetto Alberi' },
    { value: 15, label: 'Villa della Regina'},
  ];

  function getImpattoValue(label) {
    
    const item = listaImpatto.find(el => el.label === label);
    //console.log("GIV",label,item.value,item ? item.value : 0);
    return item ? item.value : 0; 
  }

  
  return (
    <div style={{ display: 'flex', marginTop: '20px', width: '100%' }}>
          <FormControl component="fieldset" style={{ marginLeft: '10px', width: '100%', minWidth: '150px',
                border: '1px solid rgba(0, 0, 0, 0.23)', borderRadius: '4px', padding: '10px' }}>
                <FormLabel component="legend" style={{ fontSize: '12px', fontWeight: '400',
                          lineHeight: '1.4375em', color:'black', display: 'block',                          
                          fontFamily: 'Roboto, Helvetica, sans-serif', paddingRight:'5px', paddingLeft:'5px'}}>
                        Monitoraggio DPP 2025-2028
                </FormLabel>
                <FormGroup>                                                               
                    <Grid container spacing={2}>
           
                    {/* Pannello Sinistro */}
                         <Grid item xs={12} sm={6}>            
                            {[...Object.keys(scelteDisponibiliDPP)
                                .slice(0, 4)]  // Prime 4 opzioni nel pannello sinistro
                                //.slice(0, 4), Object.keys(scelteDisponibiliDPP).slice(-1)[0]]  // Prime 4 opzioni nel pannello sinistro
                                .map((label) => (
                                <FormControl key={label} component="fieldset" error={!!errori[label]} sx={{ display: "flex", flexDirection: "column",  marginBottom: 2 }}>
                                    <Typography variant="subtitle1">{label}</Typography>                                    
                                        {label === "4. Priorità Tematica prevalente" ? (
                                            <RadioGroup
                                            //value={scelteDPP[label] || ""}
                                            value={scelteDPP?.[label] || ""}
                                            onChange={(e) => handleRadioChangeDPP(label, e.target.value)}
                                            >
                                            {scelteDisponibiliDPP[label].map((scelta) => (
                                                <FormControlLabel
                                                key={scelta}
                                                value={scelta}
                                                control={<Radio />}
                                                label={scelta}
                                                />
                                            ))}
                                            </RadioGroup>
                                        ) 
                                :label === "2. Concetti chiave" && Object.entries(scelteDPP?.[label] || {}).some(([key, value]) => key === 'Rischio' && value > 0) ?(                                    
                                    scelteDisponibiliDPP[label].map((scelta) => (                    
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <FormControlLabel
                                        key={scelta}
                                        control={
                                        <Checkbox                            
                                            //checked={scelte[label]?.[scelta] || false}
                                            //checked={scelteDPP[label]["Rischio"] > 0}
                                            checked={scelteDPP[label]?.[scelta] === true || scelteDPP[label]?.[scelta] > 0}  
                                            onChange={() => handleCheckboxChangeDPP(label, scelta)}
                                        />
                                        }                                        
                                        //label={scelta}                                        
                                        label={
                                          scelta === "Rischio" ? (
                                            <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                              <span>{scelta}</span>
                                              <IconButton aria-label="alarm" size="small" onClick={showInfoAboutRisks} >
                                                <HelpIcon fontSize="medium" color="primary"/>
                                              </IconButton>
                                            </div>
                                          ) : (
                                            scelta
                                          )
                                        }

                                    />     
                                    { scelta=="Rischio" ?(                                       
                                    console.log("QUI",scelta),
                                    <RadioGroup
                                    row
                                    //value={rischioLevel[label] || ""}
                                    value={scelteDPP[label]["Rischio"]}
                                    onChange={(e) => handleRischioRadioChange(label, e.target.value)}
                                    >
                                    <FormControlLabel
                                        value={1}
                                        control={<Radio />}
                                        label="Medio"
                                    />
                                    <FormControlLabel
                                        value={2}
                                        control={<Radio />}
                                        label="Alto"
                                    />
                                    </RadioGroup>     
                                    
                                    ):(console.log("QUA",scelta),
                                    <></>)}         
                                    </div>
                                ))
                                )
                                : (
                                    // Scelta multipla con checkbox
                                    scelteDisponibiliDPP[label].map((scelta) => (
                                    <FormControlLabel
                                        key={scelta}
                                        control={
                                        <Checkbox
                                            checked={scelteDPP[label]?.[scelta] || false}
                                            onChange={() => handleCheckboxChangeDPP(label, scelta)}
                                        />
                                        }
                                        //label={scelta}
                                        label={
                                          scelta === "Rischio" ? (
                                            <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                              <span>{scelta}</span>
                                              <IconButton aria-label="alarm" size="small" onClick={showInfoAboutRisks} >
                                                <HelpIcon fontSize="medium" color="primary"/>
                                              </IconButton>
                                            </div>
                                          ) : (
                                            scelta
                                          )
                                        }
                                    />
                                    ))
                                )}
                                {/* Messaggio di errore se non compilato */}
                                {errori[label] && <FormHelperText>{errori[label]}</FormHelperText>}
                                </FormControl>
                            ))}
                         </Grid>

                    {/* Pannello Destro */}
                        <Grid item xs={12} sm={6}>
            
            {Object.keys(scelteDisponibiliDPP)
              //.slice(4,7) // Ultime 2 opzioni nel pannello destro
              .slice(4,8) // Ultime 2 opzioni nel pannello destro
              .map((label) => (
                <FormControl key={label} component="fieldset" error={!!errori[label]} sx={{  display: "flex", flexDirection: "column", marginBottom: 2 }}>
                   <Typography variant="subtitle1">{label}</Typography>                  
                   {label === "6. Velocità d'intervento" ? (
                    
                    <RadioGroup
                      value={scelteDPP?.[label] || ""}
                      onChange={(e) => handleRadioChangeDPP(label, e.target.value)}
                    >
                      {scelteDisponibiliDPP[label].map((scelta) => (
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                        <FormControlLabel
                          key={scelta}
                          value={scelta}
                          control={<Radio />}
                          label={scelta}
                        />
                        { scelta=="Progetti a impatto"  && scelteDPP?.["6. Velocità d'intervento"]=="Progetti a impatto" ?(   

                        console.log("QUIMP",scelta,scelteDPP["6. Velocità d'intervento"],scelteDPP?.["100. Progetti a impatto"],listaImpatto[getImpattoValue(scelteDPP?.["100. Progetti a impatto"])]),
                        <div style={{ width: "70%"}}>
                            <Select
                              className="basic-single"
                              placeholder="Seleziona"
                              onChange={(e) => handleImpattoSelectChange(label, e)}
                              options={listaImpatto}
                              defaultValue={listaImpatto[getImpattoValue(scelteDPP?.["100. Progetti a impatto"])]}
                              />
                        </div>
                        ):(//console.log("QUA",scelta),
                        <></>)} 
                        </div>
                      ))}
                    </RadioGroup>
                   
                        
                    ) 
                   
                   //////
                   /*
                   :label === "6. Velocità d'intervento" && Object.entries(scelteDPP?.[label] || {}).some(([key, value]) => key === 'Progetti a impatto' && value > 0) ?(
                    scelteDisponibiliDPP[label].map((scelta) => (                    
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                    <FormControlLabel
                        key={scelta}
                        control={
                        <Checkbox                                                        
                            checked={scelteDPP[label]?.[scelta] === true || scelteDPP[label]?.[scelta] >0}  
                            onChange={() => handleCheckboxChangeDPP(label, scelta)}
                        />
                        }                                                                                   
                        label={
                          scelta === "Progetti a impatto" ? (
                            <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                              <span>{scelta}</span>                              
                            </div>
                          ) : (
                            scelta
                          )
                        }

                    />     
                    { scelta=="Progetti a impatto" ?(
                    console.log("QUIMP",scelta),
                    <div style={{ width: "100%"}}>
                        <Select
                          className="basic-single"
                          placeholder="Seleziona"
                          onChange={(e) => handleImpattoSelectChange(label, e)}
                          options={listaImpatto}
                          />
                    </div>
                    ):(console.log("QUA",scelta),
                    <></>)}         
                    </div>
                ))
                )  
                //////
                */   
                   
                   : label === "5. Fattori Chiave" ? (
                    console.log("WEBZ".label,scelteDisponibiliDPP[label]),
                    /*scelteDisponibiliDPP[label].map((scelta) => (
                      <FormControlLabel
                        key={scelta}                        
                        control={
                          <Checkbox
                            disabled={disabledFattoriChiave}
                            checked={scelteDPP[label]?.[scelta] || false}
                            onChange={() => handleCheckboxChangeDPP(label, scelta)}
                          />
                        }
                        label={scelta}
                      />
                    ))*/
                    scelteDisponibiliDPP[label].map((scelta) => (
                      scelta == "Nessuno" ? (
                        <FormControlLabel
                        key={scelta}                        
                        control={
                          <Checkbox
                            //disabled={!disabledFattoriChiave}
                            disabled={true}
                            checked={scelteDPP[label]?.[scelta] || false}
                            onChange={() => handleCheckboxChangeDPP(label, scelta)}
                          />
                        }
                        label={scelta}
                      />):(
                        <FormControlLabel
                        key={scelta}                        
                        control={
                          <Checkbox
                            disabled={disabledFattoriChiave}
                            checked={scelteDPP[label]?.[scelta] || false}
                            onChange={() => handleCheckboxChangeDPP(label, scelta)}
                          />
                        }
                        label={scelta}
                      />
                      )                                            
                    ))
                   )
                   
                   : (
                    // Scelta multipla con checkbox
                    scelteDisponibiliDPP[label].map((scelta) => (
                      <FormControlLabel
                        key={scelta}
                        
                        control={
                          <Checkbox
                            
                            checked={scelteDPP[label]?.[scelta] || false}
                            onChange={() => handleCheckboxChangeDPP(label, scelta)}
                          />
                        }
                        label={scelta}
                      />
                    ))
                  )}

                  {/* Messaggio di errore se non compilato */}
                  {errori[label] && <FormHelperText>{errori[label]}</FormHelperText>}
                </FormControl>
              ))}
                        </Grid>
                    </Grid>
                </FormGroup>
          </FormControl>
         
          <RiskDialog
            open={openRiskDialog}
            onClose={handleCloseRiskDialog}
          />
    </div>
  );
};

export default MonitoraggioDPP;
